
import { Component, ElementRef, OnInit } from '@angular/core';
import { PageBase, TireChangeInfo } from 't4core';
import { TireChangeDialog } from '../../../OneWayAdmin/dialogs/TireChangeDialog/TireChangeDialog';

@Component({
  styleUrls: ['./TireChange.css'],
  selector: 'TireChange',
  templateUrl: './TireChange.html',
})
export class TireChangeComponent extends PageBase implements OnInit {
    constructor(el: ElementRef) {
      super(el, "TireChanges");
  }

  public data: any[];

  public async ngOnInit() {

    this.data = await this.Api.get<TireChangeInfo[]>("RentalObject/GetTireChangeData");

  }


  public openDialog() {
    const dialogRef = this.Dialog.open(TireChangeDialog, { autoFocus: false });

    dialogRef.afterClosed().subscribe(async (result) => {
      console.log('Dialog result:', result);

      if (result) {
        this.data = await this.Api.get<TireChangeInfo[]>("RentalObject/GetTireChangeData");
      }
    });
  }



  public async delete(row: any) {

    var x: boolean = false;
    if (row.Amount > 0)
      x = await this.UI.confirm("turbo.Reports.TireChange.ConfirmDelete", "Are you sure to delete this?", "turbo.Reports.TireChange.ConfirmDeleteMessage", "Do you want to remove the debit of {0}kr, for {1}?", null, [row.Amount, row.Location.Name]);
    else if (row.Amount < 0) {
      x = await this.UI.confirm("turbo.Reports.TireChange.ConfirmDelete", "Are you sure to delete this?", "turbo.Reports.TireChange.ConfirmDeleteMessage2", "Do you want to remove the credit of {0}kr, for {1}?", null, [row.Amount, row.Location.Name]);
    }
    else if (row.Amount == 0) {
      x = await this.UI.confirm("turbo.Reports.TireChange.ConfirmDelete", "Are you sure to delete this?", "turbo.Reports.TireChange.ConfirmDeleteMessage3", "Do you want to remove the registration of a tire change for {0}?", null, [row.Location.Name]);
    }

    if (x) {
      var result = await this.Api.delete<boolean>("RentalObject/DeleteTireChange", {tireChangeId: row.Id});
      if (result) this.data = await this.Api.get<TireChangeInfo[]>("RentalObject/GetTireChangeData");
    }

  }

}
